import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';

type Props = {
  onClick: () => void;
};

export const DetailsButton: FC<Props> = memo(({ onClick }) => {
  const { t } = useTranslation();

  return (
    <ButtonV2 isSecondary isTransparent size='xs' onClick={onClick}>
      {t('import_export_history_details')}
    </ButtonV2>
  );
});

DetailsButton.displayName = 'DetailsButton';
